import { useFetch } from "@common/hooks/useFetch";
import { useEffect, useState } from "react";
import { IOffer } from "@features/cart/ICart";
import { GET_OFFER_ROUTE } from "@api-routes";
import { getResponseToState, IOfferResponse } from "@mappers/getOfferListMapper";

export const useOffers = () => {
    const [arrowStep, setArrowStep] = useState<number>(0);
    const [offerListState, { get }] = useFetch();
    const [offerList, setOfferList] = useState<IOffer[]>([]);

    const setOffers = (offers: IOffer[]) => {
        const sortedOffers = offers.map((offer) => {
            const sortedItems = [...offer.usages].sort((a, b) => a.displayOrder - b.displayOrder);

            return {
                ...offer,
                items: sortedItems,
            };
        });

        setOfferList(sortedOffers);
    };

    const getOfferList = () => {
        get<IOfferResponse[]>(GET_OFFER_ROUTE, { isSecured: false }).then((offerListResponse) => {
            if (offerListResponse) {
                setOffers(getResponseToState(offerListResponse));
            }
        });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(getOfferList, []);

    const handleBack = () => setArrowStep(arrowStep - 1);
    const handleNext = () => setArrowStep(arrowStep + 1);

    return {
        arrow: {
            arrowStep,
            handleBack,
            handleNext,
            setArrowStep,
        },
        getOfferList,
        offerList,
        offerListState,
    };
};
